import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32aa1073")

_pushScopeId("data-v-32aa1073")
const _hoisted_1 = { class: "reaction-button" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EmojiPanel = _resolveComponent("EmojiPanel")
  const _component_PopUpWithButton = _resolveComponent("PopUpWithButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PopUpWithButton, {
      class: "reaction",
      name: "ic25-hand",
      size: "25px"
    }, {
      content: _withId(() => [
        _createVNode(_component_EmojiPanel, { class: "emoji" })
      ]),
      _: 1
    })
  ]))
})